import { UserRole } from './User'

const DefaultSidebarItems = [
  {
    header: '記事',
    items: [
      {
        path: '/articles',
        icon: 'file text',
        label: 'すべての記事',
        scope: 'article',
        // Match: /articles, /articles/:status, /article, /article/:id, /article-preview/:id
        activePathPattern: /^\/(articles(\/[^\\/]+)?|article(\/[^\\/]+)?|article-preview\/[^\\/]+)$/,
      },
      {
        path: '/article-audits',
        icon: 'handshake outline',
        label: '記事監査',
        scope: 'articleAudit',
        // Match: /article-audits, /article, /article/:id, /article-preview/:id
        activePathPattern: /^\/(article-audits|article(\/[^\\/]+)?|article-preview\/[^\\/]+)$/,
      },
      {
        path: '/article-audit-summary',
        icon: 'bullhorn',
        label: '監査状況レポート',
        scope: 'articleAudit',
        // Match: /article-audit-summary, /article-audits
        activePathPattern: /^\/(article-audit-summary|article-audits)$/,
      },
      {
        path: '/outsourced-articles',
        icon: 'users',
        label: '編集委託記事',
        scope: 'outsourcedArticle',
        // Match: /outsourced-articles, /article, /article/:id, /article-preview/:id
        activePathPattern: /^\/(outsourced-articles|article(\/[^\\/]+)?|article-preview\/[^\\/]+)$/,
      },
      {
        path: '/outsourced-articles-csv',
        icon: 'users',
        label: '編集委託記事作成CSV',
        scope: 'article',
        // Match: /outsourced-articles-csv, /outsourced-articles, /article, /article/:id, /article-preview/:id
        activePathPattern: /^\/(outsourced-articles-csv|outsourced-articles|article(\/[^\\/]+)?|article-preview\/[^\\/]+)$/,
      },
    ],
  },
  {
    header: '運用',
    items: [
      {
        path: '/recommended-articles',
        icon: 'thumbs up',
        label: '編集部おすすめ枠',
        scope: 'recommendedArticle',
        // Match: /recommended-articles, /recommended-article, /recommended-article/:id
        activePathPattern: /^\/(recommended-articles|recommended-article(\/[^\\/]+)?)$/,
      },
      {
        path: '/creators',
        icon: 'user',
        label: 'クリエイター',
        scope: 'creator',
        // Match: /creators
        activePathPattern: /^\/(creators)$/,
      },
      {
        path: '/matomes',
        icon: 'star',
        label: '特集',
        scope: 'matome',
        // Match: /matomes
        activePathPattern: /^\/(matomes)$/,
      },
      {
        path: '/personality-quizzes',
        icon: 'heartbeat',
        label: '診断',
        scope: 'personalityQuiz',
        // Match: /personality-quizzes
        activePathPattern: /^\/(personality-quizzes)$/,
      },
      {
        path: '/recommended-tags',
        icon: 'key',
        label: 'キーワード',
        scope: 'recommendedTag',
        // Match: /recommended-tags
        activePathPattern: /^\/(recommended-tags)$/,
      },
      {
        path: '/management-categories',
        icon: 'sitemap',
        label: '管理用カテゴリ',
        scope: 'managementCategory',
        // Match: /management-categories
        activePathPattern: /^\/(management-categories)$/,
      },
      {
        path: '/ng-words',
        icon: 'dont',
        label: 'NGワード',
        scope: 'restrictedWord',
        // Match: /ng-words
        activePathPattern: /^\/(ng-words)$/,
      },
      {
        path: '/risk-words',
        icon: 'warning sign',
        label: 'リスクワード',
        scope: 'restrictedWord',
        // Match: /risk-words
        activePathPattern: /^\/(risk-words)$/,
      },
    ],
  },
  {
    header: 'カテゴリ',
    items: [
      {
        path: '/categories',
        icon: 'sitemap',
        label: 'カテゴリ',
        scope: 'category',
        // Match: /categories
        activePathPattern: /^\/(categories)$/,
      },
    ],
  },
  {
    header: 'タグ',
    items: [
      {
        path: '/tags',
        icon: 'tag',
        label: 'タグ',
        scope: 'tag',
        // Match: /tags
        activePathPattern: /^\/(tags)$/,
      },
      {
        path: '/tag-groups',
        icon: 'tags',
        label: 'タグ・グループ',
        scope: 'tagGroup',
        // Match: /tag-groups
        activePathPattern: /^\/(tag-groups)$/,
      },
    ],
  },
  {
    header: 'パートナー',
    items: [
      {
        path: '/cps-media',
        icon: 'rss',
        label: 'CP・メディア',
        scope: 'cp',
        // Match: /cps-media
        activePathPattern: /^\/(cps-media)$/,
      },
      {
        path: '/sponsors',
        icon: 'yen',
        label: 'スポンサー',
        scope: 'sponsor',
        // Match: /sponsors
        activePathPattern: /^\/(sponsors)$/,
      },
    ],
  },
  {
    header: 'マンガ',
    items: [
      {
        path: '/manga-series',
        icon: 'book',
        label: '連載',
        scope: 'series',
        // Match: /manga-series
        activePathPattern: /^\/(manga-series)$/,
      },
      {
        path: '/manga-popular-creators',
        icon: 'users',
        label: '人気クリエイター（TOP）',
        scope: 'mangasPopularCreator',
        // Match: /manga-popular-creators
        activePathPattern: /^\/(manga-popular-creators)$/,
      },
    ],
  },
  {
    header: 'ゲーム',
    items: [
      {
        path: '/games',
        icon: 'game',
        label: 'ゲーム',
        scope: 'game',
        // Match: /games, /game, /game/:id
        activePathPattern: /^\/(games|game(\/[^\\/]+)?)$/,
      },
      {
        path: '/game-categories',
        icon: 'block layout',
        label: 'ゲームカテゴリ',
        scope: 'gameCategory',
        // Match: /game-categories
        activePathPattern: /^\/(game-categories)$/,
      },
    ],
  },
  {
    header: '広告',
    items: [
      {
        path: '/authorized-digital-sellers',
        icon: 'buysellads',
        label: 'ads.txt',
        scope: 'authorizedDigitalSeller',
        // Match: /authorized-digital-sellers
        activePathPattern: /^\/(authorized-digital-sellers)$/,
      },
    ],
  },
  {
    header: 'Google Analytics',
    items: [
      {
        path: '/google-analytics/realtime-report',
        icon: 'chart bar outline',
        label: 'リアルタイムレポート',
        scope: 'realtimeReportGoogleAnalytics',
        // Match: /google-analytics/realtime-report
        activePathPattern: /^\/(google-analytics\/realtime-report)$/,
      },
    ],
  },
  {
    header: 'その他',
    items: [
      {
        path: '/users',
        icon: 'user',
        label: 'ユーザー',
        scope: 'user',
        // Match: /users
        activePathPattern: /^\/(users)$/,
      },
    ],
  },
]

export const SidebarItemsByRole = {
  [UserRole.USER]: [],
  [UserRole.VIEWER]: DefaultSidebarItems,
  [UserRole.ANALYST]: [
    {
      header: '記事',
      items: [
        {
          label: '編集委託記事',
          icon: 'users',
          path: '/outsourced-articles',
          scope: 'article',
          // Match: /outsourced-articles, /article, /article/:id, /article-preview/:id
          activePathPattern: /^\/(outsourced-articles|article(\/[^\\/]+)?|article-preview\/[^\\/]+)$/,
        },
      ],
    },
    {
      header: 'Google Analytics',
      items: [
        {
          label: 'リアルタイムレポート',
          icon: 'chart bar outline',
          path: '/google-analytics/realtime-report',
          scope: 'article',
          // Match: /google-analytics/realtime-report
          activePathPattern: /^\/(google-analytics\/realtime-report)$/,
        },
      ],
    },
  ],
  [UserRole.AD_MANAGER]: [
    {
      header: '広告',
      items: [
        {
          path: '/authorized-digital-sellers',
          icon: 'buysellads',
          label: 'ads.txt',
          scope: 'authorizedDigitalSeller',
          // Match: /authorized-digital-sellers
          activePathPattern: /^\/(authorized-digital-sellers)$/,
        },
      ],
    },
  ],
  [UserRole.AUDITOR]: [
    {
      header: '記事',
      items: [
        {
          path: '/article-audits',
          icon: 'handshake outline',
          label: '記事監査',
          scope: 'articleAudit',
          // Match: /article-audits, /article, /article/:id, /article-preview/:id
          activePathPattern: /^\/(article-audits|article(\/[^\\/]+)?|article-preview\/[^\\/]+)$/,
        },
        {
          path: '/article-audit-summary',
          icon: 'bullhorn',
          label: '監査状況レポート',
          scope: 'articleAudit',
          // Match: /article-audit-summary, /article-audits
          activePathPattern: /^\/(article-audit-summary|article-audits)$/,
        },
      ],
    },
    {
      header: '運用',
      items: [
        {
          path: '/ng-words',
          icon: 'dont',
          label: 'NGワード',
          scope: 'restrictedWord',
          // Match: /ng-words
          activePathPattern: /^\/(ng-words)$/,
        },
        {
          path: '/risk-words',
          icon: 'warning sign',
          label: 'リスクワード',
          scope: 'restrictedWord',
          // Match: /risk-words
          activePathPattern: /^\/(risk-words)$/,
        },
      ],
    },
  ],
  [UserRole.EDITOR]: DefaultSidebarItems,
  [UserRole.OWNER]: DefaultSidebarItems,
}
